import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { violationReportInputsSchema, type ViolationReportInputsValues } from "./schema";

/**
 * 違反報告フォームのreact-hook-form設定
 * @param registeredEmail ユーザーの登録メールアドレス
 */
export const useViolationReportForm = (registeredEmail: string) => {
  const form = useForm<ViolationReportInputsValues>({
    resolver: zodResolver(violationReportInputsSchema),
    defaultValues: {
      violationType: [],
      violationTypeOtherDetail: "",
      personInChargeName: "",
      personInChargeDetails: "",
      employmentDate: undefined,
      documentsSubmittable: false,
      registeredEmail,
      alternativeEmail: "",
    },
    mode: "onSubmit",
    shouldFocusError: false, // 自動フォーカスを無効化してカスタムスクロール処理を使用
  });

  return form;
};
